// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"950d5a06","338":"867131d8","629":"a3c9cc5d","645":"6b1f71da","883":"7d65efd1"}[chunkId] + ".chunk.js";
};